import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { AccessPage } from '@/features/access/AccessPage'
import { AccessGate } from '@/features/auth/AccessGate'
import { AuthCallbackScreen } from '@/features/auth/AuthCallbackScreen'
import { CALLBACK_PATH } from '@/features/auth/identityAuth'
import { SessionGate } from '@/features/auth/SessionGate'
import { AppLayout } from '@/features/runway/components/AppLayout'
import { DepartmentPage } from '@/features/runway/components/DepartmentPage'
import { OverviewPage } from '@/features/runway/components/OverviewPage'
import { AccountsSettingsPage } from '@/features/settings/AccountsSettingsPage'
import { DepartmentsSettingsPage } from '@/features/settings/DepartmentsSettingsPage'

function ProtectedApp() {
  return (
    <SessionGate>
      <AccessGate>
        <Routes>
          <Route element={<AppLayout />}>
            <Route index element={<OverviewPage />} />
            <Route path="departments/:code" element={<DepartmentPage />} />
            <Route path="access" element={<AccessPage />} />
            <Route path="settings/departments" element={<DepartmentsSettingsPage />} />
            <Route path="settings/accounts" element={<AccountsSettingsPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </AccessGate>
    </SessionGate>
  )
}

export function App({ queryClient }: { queryClient: QueryClient }) {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path={CALLBACK_PATH} element={<AuthCallbackScreen />} />
          <Route path="/*" element={<ProtectedApp />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
